import classNames from 'classnames'
import React from 'react'
import { Tooltip } from '../ui/tooltip'
import { State } from '../../constants'

export const resolveStateMessage = ({ value, message }) => {
    if (value.indexOf(',') === -1) {
        value = parseInt(value)
        switch (value) {
            case State.Paused:
                message = 'This item is paused'
                break
            case State.Enabled:
                message = 'This item is enabled'
                break
            case State.Archived:
                message = 'This item is archived'
                break
            default:
                console.error('Cannot resolve state message for', value)
        }
    } else {
        value = parseInt(value.split(',')[0])
    }

    return {
        value,
        message,
    }
}

export const BadgeSmall = ({ letter, classes, message, state, className }) => {
    return (
        <Tooltip content={message} interactionKind="hover">
            <div
                className={classNames(
                    'relative inline-block h-5 flex justify-center items-center w-6 text-xs rounded text-center',
                    classes,
                    className,
                )}
            >
                <StateIndicator value={state} />
                {letter}
            </div>
        </Tooltip>
    )
}

export const StateIndicator = ({ value, top = -3, left = -3 }) => {
    if (!value) {
        return null
    }

    let classes = ''
    switch (value) {
        case State.Enabled:
        case 'ENABLED':
            classes = 'bg-mjGreen-600'
            break
        case State.Archived:
        case 'ARCHIVED':
            classes = 'bg-mjDark-700'
            break
        case State.Paused:
        case 'PAUSED':
            classes = 'bg-state-paused'
            break
        default:
            classes = ''
    }

    return (
        <div
            className={classNames('absolute w-2 h-2 rounded-full', classes)}
            style={{ top, left }}
        />
    )
}

export const StateIndicatorForListItems = ({ value, top = -3, left = -3 }) => {
    if (!value) {
        return null
    }

    let classes = ''
    switch (value) {
        case State.Enabled:
            classes = 'bg-green-500'
            break
        case State.Archived:
            classes = 'bg-ochre-400'
            break
        case State.Paused:
            classes = 'bg-gray-400'
            break
        default:
            classes = ''
    }

    return (
        <div
            className={classNames('absolute w-2 h-2 rounded-full', classes)}
            style={{ top, left }}
        />
    )
}
